module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"selectionComparison":"Übersicht","scenarioComparison":"Szenarienvergleich","sharePENonRenewable":"Anteil nicht erneuerbarer Primärenergie","groupByUsage":"Nach Verwendungszweck","groupByCarrier":"Nach Energieträger","peMeasuredChart":"Messwerte","peParetoChart":"Reduktion nach Liegenschaft"}}')
  delete Component.options._Ctor
}
